var _clipPath, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQRclick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 396 396",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "ArtboardFrame"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 396,
    width: 396,
    x: 0,
    y: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48 90L48 132L90 132L132 132L132 90L132 48L90 48L48 48L48 90ZM120 90L120 120L90 120L60 120L60 90L60 60L90 60L120 60L120 90Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 90L72 108L90 108L108 108L108 90L108 72L90 72L72 72L72 90Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 48L168 54L168 60L186 60L204 60L204 72L204 84L210 84L216 84L216 90L216 96L222 96L228 96L228 114L228 132L234 132L240 132L240 108L240 84L234 84L228 84L228 78L228 72L222 72L216 72L216 60L216 48L192 48L168 48Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 156L306 156L300 156L300 168L300 180L306 180L312 180L312 186L312 192L318 192L324 192L324 180L324 168L318 168L312 168L312 162L312 156Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 240L156 246L156 252L162 252L168 252L168 258L168 264L180 264L192 264L192 270L192 276L198 276L204 276L204 270L204 264L216 264L228 264L228 258L228 252L234 252L240 252L240 240L240 228L234 228L228 228L228 234L228 240L210 240L192 240L192 246L192 252L186 252L180 252L180 246L180 240L168 240L156 240Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 168L156 174L156 180L162 180L168 180L168 174L168 168L162 168L156 168Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 120L144 132L138 132L132 132L132 138L132 144L138 144L144 144L150 144L156 144L156 150L156 156L162 156L168 156L168 162L168 168L174 168L180 168L180 162L180 156L186 156L192 156L192 162L192 168L198 168L204 168L204 174L204 180L216 180L228 180L228 186L228 192L234 192L240 192L240 186L240 180L246 180L252 180L252 186L252 192L258 192L264 192L264 186L264 180L270 180L276 180L276 186L276 192L282 192L288 192L288 180L288 168L290.594 168C290.588 167.981 290.599 167.988 290.594 167.969C290.536 167.776 290.492 167.59 290.438 167.375C290.347 167.016 290.253 166.585 290.156 166.125C289.916 164.979 289.701 163.755 289.562 162.562C289.361 160.817 289.318 159.23 289.5 157.719C289.572 157.124 289.845 156.57 290 156L288 156L288 150L288 144L276 144L264 144L264 150L264 156L258 156L252 156L252 162L252 168L246 168L240 168L240 162L240 156L234 156L228 156L228 162L228 168L222 168L216 168L216 150L216 132L210 132L204 132L204 138L204 144L186 144L168 144L168 138L168 132L162 132L156 132L156 126L156 120L150 120L144 120Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 108L132 114L132 120L138 120L144 120L144 114L144 108L138 108L132 108Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 180L168 186L168 192L174 192L180 192L180 186L180 180L174 180L168 180Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324 228L324 234L324 240L330 240L336 240L336 234L336 228L330 228L324 228Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 215.955L96 221.955L96 227.955L102 227.955L108 227.955L108 221.955L108 215.955L102 215.955L96 215.955Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 240L84 246L84 252L90 252L96 252L96 246L96 240L90 240L84 240Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 168L180 174L180 180L186 180L192 180L192 174L192 168L186 168L180 168Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 252L96 258L96 264L102 264L108 264L108 258L108 252L102 252L96 252Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 156L288 162L288 168L294 168L300 168L300 162L300 156L294 156L288 156Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 216L120 210L120 204L126 204L132 204L132 198L132 192L120 192L108 192L108 204L108 216L114 216L120 216Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238 48L238 54L238 60L232 60L226 60L226 66L226 72L238 72L250 72L250 60L250 48L244 48L238 48Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 228L144 234L144 240L138 240L132 240L132 246L132 252L144 252L156 252L156 240L156 228L150 228L144 228Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 240L132 246L132 252L126 252L120 252L120 258L120 264L132 264L144 264L144 252L144 240L138 240L132 240Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 204L60 210L60 216L66 216L72 216L72 222L72 228L60 228L48 228L48 216L48 204L54 204L60 204Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 288L192 294L192 300L198 300L204 300L204 306L204 312L192 312L180 312L180 300L180 288L186 288L192 288Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 228L78 228L60 228L60 234L60 240L78 240L96 240L96 234L96 228Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324 276L324 258L324 240L318 240L312 240L312 258L312 276L318 276L324 276Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 168L96 168L108 168L108 162L108 156L120 156L132 156L132 150L132 144L114 144L96 144L96 150L96 156L90 156L84 156L84 162L84 168Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 324L216 324L228 324L228 318L228 312L240 312L252 312L252 306L252 300L234 300L216 300L216 306L216 312L210 312L204 312L204 318L204 324Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 192L60 192L72 192L72 186L72 180L84 180L96 180L96 174L96 168L78 168L60 168L60 174L60 180L54 180L48 180L48 186L48 192Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 300L240 300L252 300L252 306L252 312L264 312L276 312L276 318L276 324L258 324L240 324L240 318L240 312L234 312L228 312L228 306L228 300Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324 204L324 192L324 180L330 180L336 180L336 168L336 156L342 156L348 156L348 174L348 192L342 192L336 192L336 198L336 204L330 204L324 204Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 120L174 120L180 120L180 114L180 108L186 108L192 108L192 114L192 120L198 120L204 120L204 126L204 132L186 132L168 132L168 126L168 120Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 108L210 108L216 108L216 102L216 96L210 96L204.062 96C204.039 96.051 204.024 96.1057 204 96.1562L204 102L204 108Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 108L162 108L168 108L168 102L168 96L162 96L156.062 96C156.039 96.051 156.024 96.1057 156 96.1562L156 102L156 108Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 60L156 60L144 60L144 66L144 72L156 72L168 72L168 66L168 60Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 90L264 132L306 132L348 132L348 90L348 48L306 48L264 48L264 90ZM336 90L336 120L306 120L276 120L276 90L276 60L306 60L336 60L336 90Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 90L288 108L306 108L324 108L324 90L324 72L306 72L288 72L288 90Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 306L48 348L90 348L132 348L132 306L132 264L90 264L48 264L48 306ZM120 306L120 336L90 336L60 336L60 306L60 276L90 276L120 276L120 306Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 306L72 324L90 324L108 324L108 306L108 288L90 288L72 288L72 306Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 264L312 270L312 276L318 276L324 276L324 270L324 264L318 264L312 264ZM312 276L306 276L300 276L300 282L300 288L306 288L312 288L312 282L312 276ZM300 288L294 288L288 288L288 294L288 300L294 300L300 300L300 294L300 288Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252 276L246 276L240 276L240 282L240 288L246 288L252 288L252 282L252 276ZM240 288L234 288L228 288L228 294L228 300L234 300L240 300L240 294L240 288Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 276L300 282L300 288L306 288L312 288L312 282L312 276L306 276L300 276ZM300 288L294 288L288 288L288 294L288 300L294 300L300 300L300 294L300 288ZM288 300L282 300L276 300L276 306L276 312L282 312L288 312L288 306L288 300Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 216L336 222L336 228L342 228L348 228L348 222L348 216L342 216L336 216ZM264 264L258 264L252 264L252 270L252 276L258 276L264 276L264 270L264 264ZM204 276L198 276L192 276L192 282L192 288L198 288L204 288L204 282L204 276Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29.0963 134.254L-29.0963 134.254C-29.0297 134.254-28.9756 134.308-28.9756 134.374L-28.9756 136.548C-28.9756 136.614-29.0297 136.668-29.0963 136.668L-29.0963 136.668C-29.163 136.668-29.2171 136.614-29.2171 136.548L-29.2171 134.374C-29.2171 134.308-29.163 134.254-29.0963 134.254Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQRclick);
export default __webpack_public_path__ + "static/media/QRclick.437edfe9a596c2ebf2a8b915aa0c035c.svg";
export { ForwardRef as ReactComponent };